import axios from 'axios';

const InsuranceService = {
  async createInsurance({ formValues, loanId }) {
    const values = { ...formValues };

    if (!values.deductible) {
      values.deductible_percent = null;
      values.all_other_deductible_amount = null;
    }

    if (!values.wind_deductible) {
      values.wind_deductible_percent = null;
      values.wind_deductible_amount = null;
    }

    const response = await axios.post('/insurance', {
      ...values,
      loan_id: loanId,
    });

    return response.data;
  },

  async updateInsurance({ insuranceId, formValues }) {
    const values = { ...formValues };

    if (!values.deductible) {
      values.deductible_percent = null;
      values.all_other_deductible_amount = null;
    }

    if (!values.wind_deductible) {
      values.wind_deductible_percent = null;
      values.wind_deductible_amount = null;
    }

    const response = await axios.put(`/insurance/${insuranceId}`, values);

    return response.data;
  },

  async deleteInsurance(insuranceId) {
    const response = await axios.delete(`/insurance/${insuranceId}`);

    return response.data;
  },

  async getInsurance(insuranceId) {
    const response = await axios.get(`/insurance/${insuranceId}`);

    return response.data;
  },

  async payInsurance(insuranceId) {
    const response = await axios.post(`/insurance/${insuranceId}/pay`);

    return response.data;
  },

  async createNextInsuranceBill(insuranceId) {
    const response = await axios.post(`/insurance/${insuranceId}/bill_next`);

    return response.data;
  },

  async createInsuranceBill(insuranceId) {
    const response = await axios.post(`/insurance/${insuranceId}/bill`);

    return response.data;
  },

  async renewInsurance(insuranceId) {
    const response = await axios.post(`/insurance/${insuranceId}/renew`);

    return response.data;
  },

  async createInsuranceRenewalInquiry(insuranceId) {
    const response = await axios.post(
      `/insurance/${insuranceId}/renewal_inquiry`
    );

    return response.data;
  },

  async createNonRenewalNotice(insuranceId) {
    const response = await axios.post(
      `/insurance/${insuranceId}/nonrenewal_notice`
    );

    return response.data;
  },
};

export default InsuranceService;
